import { FileTextOutlined, PrinterOutlined } from '@ant-design/icons';
import type { ItemType } from 'antd/es/menu/interface';
import { PrintHint } from '../components/PrintHint.tsx';
import type { PatientDataInput } from '../graphql/generated/graphql.ts';
import { usePrintEmptyLabelOf } from '../hooks/usePrintEmptyLabel.ts';
import { useCanPrint } from '../hooks/usePrinter.ts';

// a menu item cannot carry a tooltip of its own, so a disabled one says why in its label
export const printMenuItem = (key: string, label: string, canPrint: boolean, onPrint: () => void, available = true): ItemType => ({
  label: (
    <PrintHint canPrint={canPrint}>
      <span>{label}</span>
    </PrintHint>
  ),
  key,
  disabled: !canPrint || !available,
  icon: <PrinterOutlined />,
  onClick: info => {
    info.domEvent.stopPropagation();
    onPrint();
  },
});

/** The row actions every patient list offers: a Leer-Etikett and the forms. */
export const usePatientMenuItems = (onForms: (patient: PatientDataInput) => void) => {
  const canPrint = useCanPrint();
  const printEmptyLabelOf = usePrintEmptyLabelOf();

  return (patient: PatientDataInput): ItemType[] => [
    printMenuItem('empty-label', 'Leer-Etikett drucken', canPrint, () => printEmptyLabelOf(patient)),
    {
      label: 'Formulare',
      key: 'forms',
      icon: <FileTextOutlined />,
      onClick: info => {
        info.domEvent.stopPropagation();
        onForms(patient);
      },
    },
  ];
};
